/* src/app/shared/components/form-controls/ag-input-currency-v2/ag-input-currency-v2.component.scss */
.ag-form-control {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 254px;
  height: 48px;
  border-radius: 12px;
  background-color: #f2f2f2;
  border: none;
}
.ag-selector {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 64px;
  border: 1px solid #222222;
  border-radius: 8px;
  background-color: #ffffff;
  margin-right: 8px;
  -webkit-appearance: none;
  appearance: none;
  padding-top: 3px;
  padding-left: 0px;
  font-size: 12px;
  font-family: "Poppins-Regular";
  line-height: 18px;
  color: #222222;
}
.ag-value {
  font-size: 14px;
  font-family: "Poppins-Regular";
  line-height: 24px;
  color: #222222;
  margin-left: 16px;
}
input {
  width: 120px;
  background-color: #f2f2f2;
}
/*# sourceMappingURL=ag-input-currency-v2.component.css.map */
